<template>
	<AppFetchHTMLFromMonolith
		:url="Monolith.AJAX_COMPONENT.LAZY_LOADER"
		:params="params"
		:get-html-from-response="getHTMLFromResponse"
		@response="onResponse"
	/>
</template>

<script lang="ts" setup>
import { Monolith } from '@/constants/monolith';
import { isListBlockResponse, type ScoroAjaxResponse } from '@/lib/monolith';
import { computed } from 'vue';
import AppFetchHTMLFromMonolith, {
	type AppFetchHTMLFromMonolithProps,
} from './AppFetchHTMLFromMonolith';

const props = defineProps<{
	params: AppFetchHTMLFromMonolithProps['params'];
	container: string;
}>();

const emit = defineEmits<{
	(e: 'response', payload: { isEmpty: boolean }): void;
}>();

const params = computed(() => ({
	...props.params,
	containers: [props.container],
}));

const onResponse = (payload: { isEmpty: boolean }) => {
	emit('response', payload);
};

const getHTMLFromResponse = (response: ScoroAjaxResponse) => {
	if (!isListBlockResponse(response)) {
		return;
	}

	return response.data.html[props.container];
};
</script>
